/**
 * KetoScanFAB — Floating Action Button persistente, abre o QuickLogSheet.
 *
 * Renderizado como botão circular fixed bottom-right em todas as rotas
 * autenticadas. Toque único abre o Quick Log Sheet (3 acções: KetoScan,
 * Receita IA, Templates). Single entry point para registar refeição.
 *
 * Esconde-se em rotas de captura/full-screen onde já existe câmara
 * (/ketoscan, /body-twin-evolved), em auth (/login, /register), e
 * quando o utilizador não está autenticado.
 */

import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Camera } from "lucide-react";
import { motion } from "framer-motion";
import QuickLogSheet from "./QuickLogSheet";

const HIDDEN_PATHS = [
  "/ketoscan",
  "/body-twin-evolved",
  "/login",
  "/register",
  "/onboarding",
];

export default function KetoScanFAB() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  
  const path = location.pathname;
  if (HIDDEN_PATHS.includes(path)) return null;
  if (!localStorage.getItem("token")) return null;
  
  return (
    <>
      <motion.button
        data-testid="ketoscan-fab"
        onClick={() => setOpen(true)}
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        whileHover={{ scale: 1.06 }}
        whileTap={{ scale: 0.94 }}
        transition={{ type: "spring", stiffness: 280, damping: 22 }}
        className="
          fixed
          bottom-24 right-5
          md:bottom-8 md:right-8
          z-40
          w-14 h-14
          rounded-full
          bg-lime-500
          text-black
          shadow-[0_8px_28px_rgba(132,204,22,0.45)]
          flex items-center justify-center
          ring-2 ring-lime-300/40
          hover:bg-lime-400
          focus:outline-none focus:ring-4 focus:ring-lime-400/60
        "
        aria-label="Registar refeição rápido"
        title="Registar refeição"
      >
        <Camera className="w-6 h-6" strokeWidth={2.5} />
      </motion.button>
      
      <QuickLogSheet open={open} onClose={() => setOpen(false)} />
    </>
  );
}
